export default __webpack_public_path__ + "images/4efebe1aeee3972dbb4dcae067246448.png";